import * as React from 'react';
import GridRow from './GridRow';
import { IGridRowGroupProps } from './IGridRowGroupProps';
import { IGridRowGroupState } from './IGridRowGroupState';
import styles from '.././TVoSimpleGrid.module.scss';
import { ReactComponent as ArrowRight } from '../../assets/arrowRight.svg';
import { ReactComponent as ArrowSouth } from '../../assets/arrowSouth.svg';

export default class GridRowGroup extends React.Component<
  IGridRowGroupProps,
  IGridRowGroupState
> {
  constructor(props: IGridRowGroupProps) {
    super(props);

    this.state = {
      expanded: false
    };
  }

  private _expandToggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  public render() {
    return (
      <React.Fragment>
        <tr className={styles.groupHeaderRow}>
          <td colSpan={this.props.columnDefs.columns.length}>
            <div className={styles.groupHeaderLabel}>
              <div onClick={this._expandToggle}>
                {!this.state.expanded ? <ArrowRight /> : <ArrowSouth />}
                <span>{this.props.groupName}</span>
              </div>
            </div>
          </td>
        </tr>
        {this.state.expanded &&
          this.props.groupItems.length > 0 &&
          this.props.groupItems.map((item: any, index: any) => (
            <GridRow
              key={index}
              dataItem={item}
              columnDefs={this.props.columnDefs}
              onRowItemRender={this.props.onRowItemRender}
              onRowItemClick={this.props.onRowItemClick}
            />
          ))}
      </React.Fragment>
    );
  }
}
